<template>
    <footer class="footer has-cards">
        <div class="container">
                <div class="row justify-content-center text-center mb-3">
                    <div class="col-lg-8">
                        <p class="lead">the Quality+ Project was developed by</p>
                    </div>
                </div>
            <div class="row seven-cols">
                <div class="col-md-1 mb-5 mb-md-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0" style="height: 100%">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/inter_dk3.png'" class="card-img">
                            <!-- <h6 class="text-center">InterCollege</h6> -->
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/anespo2.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/c4g.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/inter_uk.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/adept2.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/kocaeli.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-1 mb-5 mb-lg-0 col-sm-3">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/partners" title="Partners" class="my-auto">
                            <img v-lazy="'img/logos/interb2.png'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="/" target="_self" rel="noopener">Quality+</a> & <a href="/" target="_self" rel="noopener">QualityVET</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="https://adeptprod-11172.web.app/" class="nav-link" target="_blank" rel="noopener">IT Tool</a>
                        </li>
                        <li class="nav-item">
                            <a href="/" class="nav-link" target="_self" rel="noopener">Project</a>
                        </li>
                        <li class="nav-item">
                            <a href="/partners" class="nav-link" target="_self" rel="noopener">Partners</a>
                        </li>
                        <li class="nav-item" style="width: 50%; margin-top: -20px; margin-left: -40px">
                            <a href="/"
                               class="nav-link" target="_self" rel="noopener">
                            <img v-lazy="'img/logos/erasmus.svg'" class="card-img"></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>

@media (min-width: 768px){
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1  {
    width: 100% !important;
    *width: 100%;
  }
}

@media (min-width: 992px) {
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1 {
    width: 14.285714285714285714285714285714% !important;
    *width: 14.285714285714285714285714285714%;
    flex: 0 0 14.28%;
    max-width: 14.28%;
  }
}

/**
 *  The following is not really needed in this case
 *  Only to demonstrate the usage of @media for large screens
 */    
@media (min-width: 1200px) {
  .seven-cols .col-md-1,
  .seven-cols .col-sm-1,
  .seven-cols .col-lg-1 {
    width: 14.285714285714285714285714285714% !important;
    *width: 14.285714285714285714285714285714%;
  }
}
</style>
